// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".BadgeNew{display:inline-block;white-space:nowrap;vertical-align:middle;padding:2px 7px;text-transform:uppercase;border-radius:var(--radius-md);font-weight:600;background-color:#0834ff;color:white;font-size:10px}\n", ""]);
// Exports
module.exports = exports;
